export const defaultEntity = "generi";
export const entities = ["generi"];
export const labels = {
  generi: "Generi",
};
